// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NOTE: No backdrop here — GlobalPopupProvider owns the overlay/backdrop layer. */

/* ── Modal shell ── */
.scl--cms-components-viewMedia-modal {
  position: relative;
  width: 941px;
  height: 602px;
  background: #FFFFFF;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  z-index: 200;
  flex-direction: column;
  box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.12);
}

/* ── Header ── */
.scl--cms-components-viewMedia-header {
  box-sizing: border-box;
  position: relative;
  width: 100%;
  height: 65px;
  flex-shrink: 0;
  background: #F8F9FB;
  border-bottom: 1px solid rgba(229, 229, 231, 0.5);
  display: flex;
  align-items: center;
  padding: 0 24px;
}

.scl--cms-components-viewMedia-title {
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 30px;
  line-height: 36px;
  color: #323539;
  margin: 0;
  flex: 1;
}

.scl--cms-components-viewMedia-closeBtn {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-30%);
}

/* ── Body ── */
.scl--cms-components-viewMedia-body {
  display: flex;
  flex-direction: row;
  flex: 1;
  min-height: 0;
  position: relative;
}

/* ── Vertical divider ── */
.scl--cms-components-viewMedia-divider {
  position: absolute;
  left: 458px;
  top: 0;
  bottom: 0;
  width: 1px;
  background: rgba(229, 229, 231, 0.5);
  pointer-events: none;
}

/* ── Left Panel ── */
.scl--cms-components-viewMedia-left {
  width: 458px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 16px;
  box-sizing: border-box;
}

/* Image preview */
.scl--cms-components-viewMedia-imageWrapper {
  width: 100%;
  height: 255px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
  box-shadow: 0px 4px 32px -4px rgba(111, 108, 143, 0.12),
              0px 3px 12px -2px rgba(170, 170, 190, 0.06);
}

.scl--cms-components-viewMedia-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* ── Action buttons ── */
.scl--cms-components-viewMedia-actions {
  display: flex;
  flex-direction: column;
  gap: 11px;
  width: 100%;
}


.scl--cms-components-viewMedia-actionDivider {
  width: 100%;
  height: 1px;
  background: rgba(229, 229, 231, 0.5);
}

/* ── Right Panel ── */
.scl--cms-components-viewMedia-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  position: relative;
  padding: 24px 24px 0 24px;
  box-sizing: border-box;
}

/* Edit icon button — top right of right panel */
.scl--cms-components-viewMedia-editBtn {
  position: absolute;
  top: 16px;
  right: 20px;
  width: 30px;
  height: 30px;
}
.scl--cms-components-viewMedia-editBtn .scl-components-button-RoundSqureButton{
  padding: 5px 3px 5px 9px !important;
  height: 33px;
}
.scl--cms-components-viewMedia-editBtn .scl-components-button-RoundSqureButton-md{
  min-width: 20px;
}

/* ── Detail rows ── */
.scl--cms-components-viewMedia-details {
  display: flex;
  flex-direction: column;
  gap: 25px;
  margin-top: 8px;
}

.scl--cms-components-viewMedia-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 40px;
  width: 100%;
}

.scl--cms-components-viewMedia-label {
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 12px;
  color: #8A8B8F;
  min-width: 100px;
  flex-shrink: 0;
}

.scl--cms-components-viewMedia-value {
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #323539;
}

/* Status row — gap is smaller per Figma (25px) */
.scl--cms-components-viewMedia-row:last-child {
  gap: 25px;
}

/* ── Footer ── */
.scl--cms-components-viewMedia-footer {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 0 24px 23px 24px;
  position: absolute;
  right: 0;
  bottom: 0;
}
.scl-components-button-RoundSqureButton-danger{
  background: var(--secondarycolors-red400);
}
.scl-components-button-RoundSqureButton-danger:hover{
  background: var(--primarypalette-red);
}
.scl-components-button-RoundSqureButton-danger:active{
  box-shadow:  0px 0px 0px 2px #FFFFFF 0px 0px 0px 3.5px #EF5350D9;

}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/texteditor-fs-cp/view-media-overlay/css/viewMediaOverlay.css"],"names":[],"mappings":"AAAA,kFAAkF;;AAElF,sBAAsB;AACtB;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA,iBAAiB;AACjB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,OAAO;EACP,aAAa;EACb,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,SAAS;EACT,UAAU;EACV,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,SAAS;EACT,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd;yDACuD;AACzD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;;AAGA;EACE,WAAW;EACX,WAAW;EACX,oCAAoC;AACtC;;AAEA,sBAAsB;AACtB;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;AACd;AACA;EACE,mCAAmC;EACnC,YAAY;AACd;AACA;EACE,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,iDAAiD;AACjD;EACE,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,qCAAqC;AACvC;AACA;EACE,gEAAgE;;AAElE","sourcesContent":["/* NOTE: No backdrop here — GlobalPopupProvider owns the overlay/backdrop layer. */\n\n/* ── Modal shell ── */\n.scl--cms-components-viewMedia-modal {\n  position: relative;\n  width: 941px;\n  height: 602px;\n  background: #FFFFFF;\n  border-radius: 8px;\n  overflow: hidden;\n  display: flex;\n  z-index: 200;\n  flex-direction: column;\n  box-shadow: 0px 8px 32px rgba(0, 0, 0, 0.12);\n}\n\n/* ── Header ── */\n.scl--cms-components-viewMedia-header {\n  box-sizing: border-box;\n  position: relative;\n  width: 100%;\n  height: 65px;\n  flex-shrink: 0;\n  background: #F8F9FB;\n  border-bottom: 1px solid rgba(229, 229, 231, 0.5);\n  display: flex;\n  align-items: center;\n  padding: 0 24px;\n}\n\n.scl--cms-components-viewMedia-title {\n  font-family: 'Inter', sans-serif;\n  font-weight: 600;\n  font-size: 30px;\n  line-height: 36px;\n  color: #323539;\n  margin: 0;\n  flex: 1;\n}\n\n.scl--cms-components-viewMedia-closeBtn {\n  position: absolute;\n  right: 20px;\n  top: 50%;\n  transform: translateY(-30%);\n}\n\n/* ── Body ── */\n.scl--cms-components-viewMedia-body {\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n  min-height: 0;\n  position: relative;\n}\n\n/* ── Vertical divider ── */\n.scl--cms-components-viewMedia-divider {\n  position: absolute;\n  left: 458px;\n  top: 0;\n  bottom: 0;\n  width: 1px;\n  background: rgba(229, 229, 231, 0.5);\n  pointer-events: none;\n}\n\n/* ── Left Panel ── */\n.scl--cms-components-viewMedia-left {\n  width: 458px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  padding: 24px;\n  gap: 16px;\n  box-sizing: border-box;\n}\n\n/* Image preview */\n.scl--cms-components-viewMedia-imageWrapper {\n  width: 100%;\n  height: 255px;\n  border-radius: 8px;\n  overflow: hidden;\n  flex-shrink: 0;\n  box-shadow: 0px 4px 32px -4px rgba(111, 108, 143, 0.12),\n              0px 3px 12px -2px rgba(170, 170, 190, 0.06);\n}\n\n.scl--cms-components-viewMedia-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n/* ── Action buttons ── */\n.scl--cms-components-viewMedia-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 11px;\n  width: 100%;\n}\n\n\n.scl--cms-components-viewMedia-actionDivider {\n  width: 100%;\n  height: 1px;\n  background: rgba(229, 229, 231, 0.5);\n}\n\n/* ── Right Panel ── */\n.scl--cms-components-viewMedia-right {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  position: relative;\n  padding: 24px 24px 0 24px;\n  box-sizing: border-box;\n}\n\n/* Edit icon button — top right of right panel */\n.scl--cms-components-viewMedia-editBtn {\n  position: absolute;\n  top: 16px;\n  right: 20px;\n  width: 30px;\n  height: 30px;\n}\n.scl--cms-components-viewMedia-editBtn .scl-components-button-RoundSqureButton{\n  padding: 5px 3px 5px 9px !important;\n  height: 33px;\n}\n.scl--cms-components-viewMedia-editBtn .scl-components-button-RoundSqureButton-md{\n  min-width: 20px;\n}\n\n/* ── Detail rows ── */\n.scl--cms-components-viewMedia-details {\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n  margin-top: 8px;\n}\n\n.scl--cms-components-viewMedia-row {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 40px;\n  width: 100%;\n}\n\n.scl--cms-components-viewMedia-label {\n  font-family: 'Inter', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 12px;\n  color: #8A8B8F;\n  min-width: 100px;\n  flex-shrink: 0;\n}\n\n.scl--cms-components-viewMedia-value {\n  font-family: 'Inter', sans-serif;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 20px;\n  color: #323539;\n}\n\n/* Status row — gap is smaller per Figma (25px) */\n.scl--cms-components-viewMedia-row:last-child {\n  gap: 25px;\n}\n\n/* ── Footer ── */\n.scl--cms-components-viewMedia-footer {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  padding: 0 24px 23px 24px;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n}\n.scl-components-button-RoundSqureButton-danger{\n  background: var(--secondarycolors-red400);\n}\n.scl-components-button-RoundSqureButton-danger:hover{\n  background: var(--primarypalette-red);\n}\n.scl-components-button-RoundSqureButton-danger:active{\n  box-shadow:  0px 0px 0px 2px #FFFFFF 0px 0px 0px 3.5px #EF5350D9;\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
